const page_wcdlp = {
    init: () => {

        $(document).ready(function() {
            $('.staff-slider-wrapper').slick({
                infinite: true,
                slidesToShow: 2,
                slidesToScroll: 1,
                arrows: true,
                responsive: [
                    {
                    breakpoint: 769,
                        settings: {
                            slidesToShow: 1.05,
                            slidesToScroll: 1,
                            dots: true,
                            arrows: false
                        }
                    }
                ]
                });
            });
            var clicks = 0;
            $(document).on('click', '.staff-slider-next', function() {

                var slides = $('.staff-slide.slick-slide').length -1;
                if (clicks < slides ) {
                    $('.staff-slider-wrapper').slick('slickNext');
                    clicks += 1;
                }
                else if (clicks >= slides ) {
                    $('.staff-slider-wrapper').slick('slickPrev');
                    clicks = 0;
                }

        });

        // open modal
        $(".notify-btn").on("click", function() {
            $("#notify-overlay").removeClass("notify-hide");
            $("body").addClass("no-scroll");
        });

        // click "x", close modal
        $("#notify-close").on("click", function() {
            $("#notify-overlay").addClass("notify-hide");
            $("body").removeClass("no-scroll");
        });

        // click outside, close modal
        $('#notify-overlay').click(function (event) {
            if(!$(event.target).closest('.modal-outer').length && !$(event.target).is('.modal-outer')) {
                $("#notify-overlay").addClass("notify-hide");
                $("body").removeClass("no-scroll");
            }     
        });
        
        // upon submit
        $(".klaviyo-form-SAanpE button").on("click", function() {
            $(".email-eyebrow").addClass("notify-hide");
            console.log("got here");
        });

        // show video
        $("#watch-now-btn").on("click", function() {
            $("#youtube-video-embed").removeClass("video-hide");
            $("#video-thumb").addClass("thumb-content-hide");
            $("#watch-now-btn-mobile").addClass("thumb-content-hide");
        });

        $("#watch-now-btn-mobile").on("click", function() {
            $("#youtube-video-embed").removeClass("video-hide");
            $("#watch-now-btn-mobile").addClass("thumb-content-hide");
            $("#video-thumb").addClass("thumb-content-hide");
        });

    }
  };
  export default page_wcdlp;
  